var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c(
        "el-menu",
        {
          staticClass: "el-menu-demo",
          attrs: { "default-active": _vm.activeIndex, mode: "horizontal" },
          on: {
            select: function($event) {
              return _vm.handover($event)
            }
          }
        },
        [
          _c("el-menu-item", { attrs: { index: "communicationList" } }, [
            _vm._v(" " + _vm._s(_vm.$t("vipContactList")) + " ")
          ]),
          _c("el-menu-item", { attrs: { index: "emialList" } }, [
            _vm._v(" " + _vm._s(_vm.$t("templateEmail")) + " ")
          ]),
          _c("el-menu-item", { attrs: { index: "vipActivation" } }, [
            _vm._v(" " + _vm._s(_vm.$t("vipUserActivity")) + " ")
          ])
        ],
        1
      ),
      _c("communicationList", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.activeIndex == "communicationList",
            expression: "activeIndex == 'communicationList'"
          }
        ],
        ref: "communicationList"
      }),
      _c("emialList", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.activeIndex == "emialList",
            expression: "activeIndex == 'emialList'"
          }
        ],
        ref: "emialList"
      }),
      _c("vipActivation", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.activeIndex == "vipActivation",
            expression: "activeIndex == 'vipActivation'"
          }
        ],
        ref: "vipActivation"
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }